import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getSavedInterfaceLanguage, saveInterfaceLanguageToLocalStorage } from '../../utils/themeStorage';

const LanguageSelect = () => {
    const { i18n } = useTranslation();
    const [currentLanguage, setCurrentLanguage] = useState('ru');

    // Загружаем сохраненный язык при инициализации
    useEffect(() => {
        const savedLanguage = getSavedInterfaceLanguage();
        if (savedLanguage !== i18n.language) {
            i18n.changeLanguage(savedLanguage);
        }
        setCurrentLanguage(savedLanguage);
    }, [i18n]);

    // Обработчик смены языка
    const handleLanguageChange = () => {
        const newLanguage = currentLanguage === 'ru' ? 'en' : 'ru';
        i18n.changeLanguage(newLanguage);
        saveInterfaceLanguageToLocalStorage(newLanguage);
        setCurrentLanguage(newLanguage);
    };

    return (
        <button
            onClick={handleLanguageChange}
            className="w-full px-3 py-2 text-sm bg-gray-700 hover:bg-gray-600 text-white rounded transition-colors"
            title={`Текущий язык: ${currentLanguage === 'ru' ? 'Русский' : 'English'}. Нажмите для смены.`}
        >
            {currentLanguage === 'ru' ? '🇷🇺 Русский' : '🇺🇸 English'}
        </button>
    );
};

export default LanguageSelect;
